<app-content-container>
  <div class="flex justify-center">
    <div class="w-full">
      <h2 class="section-title text-center mb-8">
        Veja o que dizem os nossos alunos
      </h2>

      <swiper-container
        #swiper
        class="mt-20"
        pagination="false"
        effect="slide"
        grab-cursor="true"
        centered-slides="false"
        autoplay="true"
        loop="true"
        init="false"
      >
        @for (item of reviews(); track item.text) {
        <swiper-slide class="card m-2 min-h-[450px]">
          <div
            class="card-body bg-[#161E2E]/60 backdrop-blur-md border border-white/10 hover:border-primary hover:shadow-[0_0_20px_rgba(102,87,236,0.2)] transition-all duration-300 rounded-2xl"
          >
            <app-truncate-review
              class="mb-8 text-base"
              [text]="item.text"
            ></app-truncate-review>
            <div class="flex items-center space-x-4 mt-auto">
              <figure class="block rounded w-14 h-14 relative">
                <img
                  [ngSrc]="item.avatar"
                  fill
                  [alt]="'Aluno(a) ' + item.author"
                />
              </figure>
              <div class="flex flex-col">
                <strong class="text-base">{{ item.author }}</strong>
                <div class="text-xs">{{ item.role }}</div>
              </div>
            </div>
          </div>
        </swiper-slide>
        }
      </swiper-container>
    </div>
  </div>

  <div class="flex justify-center mt-16">
    <ng-content select="[price-btn]"></ng-content>
  </div>
</app-content-container>
